import { render, staticRenderFns } from "./StatusEffect.vue?vue&type=template&id=76f852a4&scoped=true&"
import script from "./StatusEffect.vue?vue&type=script&lang=js&"
export * from "./StatusEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f852a4",
  null
  
)

export default component.exports